// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  color: white;
  font-size: 20px;
  font-weight: 500;
  width: 100%;
  height: 48px;
  z-index: 550;
  -webkit-user-select: none;
          user-select: none;
  background-color: white;
}
.bottom-bar.bottom-bar-split {
  display: flex;
}
.bottom-bar.bottom-bar-split > * {
  background: linear-gradient(90deg, #0d6efd 0%, #495afc 100%);
  flex: 1 1;
}
.bottom-bar.bottom-bar-split > *.gray-theme {
  background: #c1c7cd;
}
.bottom-bar.bottom-bar-split > *.orange-theme {
  background: #d98c00;
}
.bottom-bar .bottom-bar-main {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(90deg, #0d6efd 0%, #495afc 100%);
  margin: auto;
  height: 100%;
  width: min(768px, 100vw);
}
.bottom-bar .bottom-bar-main:hover {
  cursor: pointer;
}
.bottom-bar .bottom-bar-main.has-arrow {
  justify-content: space-between;
}
.bottom-bar .bottom-bar-main.vat-theme {
  background: #d98c00;
  color: white;
}
.bottom-bar .bottom-bar-main.disabled {
  color: white;
  background: #c1c7cd;
}
.bottom-bar .bottom-bar-main.disabled:hover {
  cursor: not-allowed;
}

.bottom-bar-split-extra {
  position: fixed;
  bottom: 0;
  left: 0;
  color: white;
  font-size: 20px;
  font-weight: 500;
  width: 100%;
  height: 48px;
  z-index: 550;
  -webkit-user-select: none;
          user-select: none;
  background-color: white;
}
.bottom-bar-split-extra .bottom-bar-main {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(90deg, #0d6efd 0%, #495afc 100%);
  margin: auto;
  height: 100%;
  width: min(768px, 100vw);
}
.bottom-bar-split-extra .bottom-bar-main:hover {
  cursor: pointer;
}
.bottom-bar-split-extra .bottom-bar-main.has-arrow {
  justify-content: space-between;
}
.bottom-bar-split-extra .bottom-bar-main.vat-theme {
  background: #d98c00;
  color: white;
}
.bottom-bar-split-extra .bottom-bar-main.disabled {
  color: white;
  background: #c1c7cd;
}
.bottom-bar-split-extra .bottom-bar-main.disabled:hover {
  cursor: not-allowed;
}
.bottom-bar-split-extra .bottom-bar-main .bottom-bar-split-item {
  height: 100%;
  flex-grow: 1;
  background: linear-gradient(90deg, #0d6efd 0%, #495afc 100%);
  flex: 1 1;
}
.bottom-bar-split-extra .bottom-bar-main .bottom-bar-split-item.gray-theme {
  background: #c1c7cd;
}
.bottom-bar-split-extra .bottom-bar-main .bottom-bar-split-item.orange-theme {
  background: #d98c00;
}`, "",{"version":3,"sources":["webpack://./src/components/Commons/BottomBar/bottomBar.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;EACA,uBAAA;AADF;AAEE;EACE,aAAA;AAAJ;AACI;EACE,4DAAA;EACA,SAAA;AACN;AAAM;EACE,mBCSY;ADPpB;AAAM;EACE,mBCdO;ADgBf;AAEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4DAAA;EACA,YAAA;EACA,YAAA;EACA,wBCZQ;ADYZ;AACI;EACE,eAAA;AACN;AACI;EACE,8BAAA;AACN;AACI;EACE,mBAAA;EACA,YAAA;AACN;AACI;EACE,YAAA;EACA,mBClBc;ADmBpB;AAAM;EACE,mBAAA;AAER;;AAIA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;EACA,uBAAA;AADF;AAGE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4DAAA;EACA,YAAA;EACA,YAAA;EACA,wBCrDQ;ADoDZ;AAEI;EACE,eAAA;AAAN;AAEI;EACE,8BAAA;AAAN;AAEI;EACE,mBAAA;EACA,YAAA;AAAN;AAEI;EACE,YAAA;EACA,mBC3Dc;AD2DpB;AACM;EACE,mBAAA;AACR;AAGI;EACE,YAAA;EACA,YAAA;EACA,4DAAA;EACA,SAAA;AADN;AAEM;EACE,mBCvEY;ADuEpB;AAEM;EACE,mBC9FO;AD8Ff","sourcesContent":["@import \"styles/variables\";\n\n.bottom-bar {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  color: white;\n  font-size: 20px;\n  font-weight: 500;\n  width: 100%;\n  height: 48px;\n  z-index: 550;\n  user-select: none;\n  background-color: white;\n  &.bottom-bar-split {\n    display: flex;\n    & > * {\n      background: linear-gradient(90deg, $blue 0%, $vat-theme-color 100%);\n      flex: 1;\n      &.gray-theme {\n        background: $more-lighter-gray;\n      }\n      &.orange-theme {\n        background: $orange-color;\n      }\n    }\n  }\n  .bottom-bar-main {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: linear-gradient(90deg, $blue 0%, $vat-theme-color 100%);\n    margin: auto;\n    height: 100%;\n    width: $app-width;\n    &:hover {\n      cursor: pointer;\n    }\n    &.has-arrow {\n      justify-content: space-between;\n    }\n    &.vat-theme {\n      background: #d98c00;\n      color: white;\n    }\n    &.disabled {\n      color: white;\n      background: $more-lighter-gray;\n      &:hover {\n        cursor: not-allowed;\n      }\n    }\n  }\n}\n\n.bottom-bar-split-extra {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  color: white;\n  font-size: 20px;\n  font-weight: 500;\n  width: 100%;\n  height: 48px;\n  z-index: 550;\n  user-select: none;\n  background-color: white;\n\n  .bottom-bar-main {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: linear-gradient(90deg, $blue 0%, $vat-theme-color 100%);\n    margin: auto;\n    height: 100%;\n    width: $app-width;\n    &:hover {\n      cursor: pointer;\n    }\n    &.has-arrow {\n      justify-content: space-between;\n    }\n    &.vat-theme {\n      background: #d98c00;\n      color: white;\n    }\n    &.disabled {\n      color: white;\n      background: $more-lighter-gray;\n      &:hover {\n        cursor: not-allowed;\n      }\n    }\n\n    .bottom-bar-split-item {\n      height: 100%;\n      flex-grow: 1;\n      background: linear-gradient(90deg, $blue 0%, $vat-theme-color 100%);\n      flex: 1;\n      &.gray-theme {\n        background: $more-lighter-gray;\n      }\n      &.orange-theme {\n        background: $orange-color;\n      }\n    }\n  }\n}\n","$small-screen: 100vw;\n$medium-screen: 80vw;\n$large-screen: 60vw;\n$xlarge-screen: 40vw;\n$label1-color: #383850;\n$label2-color: #999999;\n$label3-color: #3d2f31;\n$theme-color-primary: #6b63ff;\n$theme-color-primary-light: #6b63ffc5;\n$orange-color: #d98c00;\n$light-orange-color: #f2a61c;\n$yellow-color-light: #ffc145d0;\n$yellow-color-new: #ffc519;\n$vat-theme-color: #495afc;\n$vat-theme-color-dark: #4251e3;\n$vat-theme-color-dark-more: #3b49cc;\n$blue-red-color: #d98c00;\n$yellow-theme-color: #ffc145;\n$red-color: #f80707;\n$deep-red-color: #cb2128;\n$green-color: #4aba64;\n$light-green: #00b33c;\n$app-width: min(768px, 100vw);\n$app-width-extra: min(768px, 101vw);\n$semi-black: #121619;\n$light-black: #373b3e;\n$gray: #67686a;\n$light-gray: #93969a;\n$lighter-gray: #c4c4c4;\n$more-lighter-gray: #c1c7cd;\n$light-white: #fafafa;\n$lighter-white: #f2f4f8;\n$lighter-white2: #f4f5ff;\n$purple: #6c63ff;\n$yellow: #ffe800;\n$blue: #0d6efd;\n$common-border-color: #dde1e6;\n$other-gray: #878d96;\n$app-gray-1: #697077;\n$app-dark-gray: #697077;\n$white: #ffffff;\n$toss-navy: #435a78;\n$toss-ivory: #f9fafb;\n$toss-black: #333d4b;\n$toss-gray: #f3f4f6;\n$toss-blue: #4493fc;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
